// @ts-check
import { playerBody } from './power.js';
/** Pipes require Down; doorways accept a grounded walk-in or landing.
 * @param {import('./types.js').Level} level @param {import('./player.js').Position} player @param {boolean} down
 */
export function secretAt(level, player, down) {
  const body = playerBody(player);
  return level.definition.portals?.find(p => {
    if (level.signals[`visited:${p.id}`] || p.reveal && !level.solids.find(s => s.id === p.reveal)?.used) return false;
    const centered = Math.abs(player.x + body.width / 2 - p.x - p.width / 2) <= Math.max(8, p.width * .23);
    const inside = player.x + body.width > p.x + 4 && player.x < p.x + p.width - 4;
    return player.grounded && Math.abs(player.y - p.y) < 3 && (p.kind === 'pipe' ? down && centered : inside);
  });
}
